import { render, staticRenderFns } from "./HowToBuy.vue?vue&type=template&id=b5fdb9fc&scoped=true&"
import script from "./HowToBuy.vue?vue&type=script&lang=js&"
export * from "./HowToBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fdb9fc",
  null
  
)

export default component.exports